import $ from 'jquery';

jQuery(function() {
	let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;

	const setVh = function() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh',`${vh}px`);
	}

	$(window).on('resize',function() {
		let w = window.innerWidth;
        let h = window.innerHeight;
		if(w != windowWidth || h != windowHeight) {
			setVh();
		}
	});

	setVh();

});
